enum MergeConflictCaller {
	Sync = "Sync",
	Branch = "Branch",
}

export default MergeConflictCaller;
